(function(){
  function activate(video){
    if(!video || video.dataset.activated) return;
    var src = video.getAttribute('data-src');
    if(!src) return;
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.dataset.activated = 'true';
    video.load();
  }

  function play(video){
    if(!video) return;
    activate(video);
    var p = video.play();
    if(p && p.catch){ p.catch(function(){}); }
  }

  function stop(video){
    if(!video) return;
    try{ video.pause(); video.currentTime = 0; }catch(e){}
  }

  document.addEventListener('mouseenter', function(e){
    var wrapper = e.target.closest && e.target.closest('.card-wrapper');
    if(!wrapper) return;
    var video = wrapper.querySelector('.card__hover-video[data-src]');
    if(video) play(video);
  }, true);

  document.addEventListener('mouseleave', function(e){
    var wrapper = e.target.closest && e.target.closest('.card-wrapper');
    if(!wrapper) return;
    var video = wrapper.querySelector('.card__hover-video[data-src]');
    if(video) stop(video);
  }, true);
})();
